import classnames from 'classnames';
import React from 'react';

const CSS = require('./SectionTitle.module.scss');

interface SectionTitleProps {
  children?: any;
  className?: string;
  bottomSpacing?: boolean;
  color?: 'purple' | 'sandstone';
}

function SectionTitle({
  children,
  className,
  bottomSpacing = false,
  color = 'purple',
}: SectionTitleProps) {
  const classes = classnames(CSS.SectionTitle, {
    [CSS.BottomSpacing]: bottomSpacing,
    [className]: className,
  });

  return (
    <h1 className={classes} data-variant={color}>
      {children}
    </h1>
  );
}

export default SectionTitle;
